module.exports = __webpack_public_path__ + "media/images/log/log-graph-bg-005399f1e7427a355b34b8b9f376658c.png";